import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {TheBorder} from "../../TheBorder";
import {gsap, TimelineMax} from "gsap";

/**
 * Created by Jerker Nord on 2022-05-03.
 */

export class TheBorderSpinEndRunner implements SimplePresentation {

    private _mainTL: TimelineMax;

    constructor() {
    }

    public shouldRun(): boolean {
        if (TheBorderGameMode.isEndOfAvalanche(TheBorder.model.gameData.mode, TheBorder.model.gameData.nextMode)) {
            return true;
        }

        return (TheBorder.model.gameData.mode === TheBorder.model.gameData.nextMode);
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._mainTL = gsap.timeline({onComplete: controller.finish});
        this._mainTL.add(() => {
            TheBorder.xNudgeSymbols.turnOffAllXNudgeSymbols();
            TheBorder.scatterSymbols.turnOffAllScatterSymbols();

            // #346 => normal and normal_avalanche modes only AND next up is not any bonus mode
            if (TheBorder.model.gameData.mode.indexOf(TheBorderGameMode.NORMAL) > -1 && !TheBorder.model.gameData.freespinTriggeredThisSpin) {
                TheBorder.backgroundElements.playBackgroundAnim("idle", -1);
            }
        });
        if (TheBorder.autoPlayPlugin.isAutoplayRound || TheBorder.model.gameData.nextMode == TheBorderGameMode.FREESPIN) {
            if (TheBorder.model.gameData.betClusterWins.length == 0) {
                this._mainTL.add(gsap.timeline({delay: 0.3}));
            }
        }
        if (this._mainTL.duration() == 0) {
            this._mainTL.add(gsap.to(this, {duration: 0.001}));
        }
    }
}